export const identityPoolId = process.env['GATSBY_IDENTITY_POOL_ID'];
export const roleArn = process.env['GATSBY_EVIDENTLY_ROLE_ARN'];
export const projektName = process.env['GATSBY_EVIDENTLY_PROJECT_NAME'];

export const roleSessionName = 'a_b_testing_role';
export const userIdKey = 'mewa.a-b-testing-user-id';
